import SafeLottie from './SafeLottie';
import Editable from './Editable';
import type { Translations, SeoData } from '../types';
import { assets } from '../assetsConfig';

interface ServicesProps {
  t: Translations;
  seo: SeoData;
  isEditable: boolean;
  onUpdate: (key: string, val: string) => void;
}

export default function Services({ t, seo, isEditable, onUpdate }: ServicesProps) {
  return (
    <section id="leistungen" className="w-full bg-white py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-32 items-center">
          
          <div className="flex flex-col justify-center reveal-on-scroll">
            <div className="-ml-4 mb-2 w-[100px] h-[100px]">
              <SafeLottie animationData={assets.anim.handshake} loop={true} />
            </div>
            <span className="text-care font-bold tracking-wider uppercase mb-3 flex items-center gap-2">
              <i className="ri-briefcase-4-line text-xl"></i> 
              <Editable isEditable={isEditable} value={t.services_badge} onChange={(v) => onUpdate('services_badge', v)} as="span" />
            </span>
            <Editable isEditable={isEditable} value={t.services_heading} onChange={(v) => onUpdate('services_heading', v)} as="h2" className="text-3xl sm:text-4xl lg:text-4xl font-extrabold text-prestige leading-[1.2] py-2" multiline />
            
            <Editable isEditable={isEditable} value={t.services_desc} onChange={(v) => onUpdate('services_desc', v)} as="div" className="mt-6 text-base md:text-lg text-slate-600 leading-relaxed py-2" multiline />

            <div className="mt-10 space-y-6">
              {[
                { title: 'services_card1_title', desc: 'services_card1_desc', icon: 'ri-shield-check-fill' },
                { title: 'services_card2_title', desc: 'services_card2_desc', icon: 'ri-file-paper-2-fill' },
                { title: 'services_card3_title', desc: 'services_card3_desc', icon: 'ri-customer-service-2-fill' }
              ].map((card, idx) => (
                <div key={idx} className="group flex flex-col sm:flex-row gap-5 p-6 bg-[#FAF8F5] rounded-3xl hover:bg-white hover:shadow-xl transition-all duration-300 border border-transparent hover:border-prestige/10 hover:-translate-y-1">
                  <div className="w-16 h-16 bg-white rounded-2xl flex items-center justify-center text-prestige shadow-md group-hover:scale-110 group-hover:bg-[#125b60] group-hover:text-white transition-all duration-300 shrink-0">
                    <i className={`${card.icon} text-3xl`}></i>
                  </div>
                  <div className="w-full">
                    <Editable isEditable={isEditable} value={t[card.title]} onChange={(v) => onUpdate(card.title, v)} as="h3" className="font-bold text-xl text-prestige" />
                    <Editable isEditable={isEditable} value={t[card.desc]} onChange={(v) => onUpdate(card.desc, v)} as="p" className="text-slate-600 mt-2 leading-relaxed text-sm sm:text-base" multiline />
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative w-full max-w-lg lg:max-w-xl mx-auto lg:mx-0 lg:ml-auto reveal-on-scroll">
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[100%] h-[100%] bg-[#FAF8F5] rounded-full filter blur-3xl opacity-90 z-0 pointer-events-none"></div>
            <div className="relative z-10 animate-float-slow">
              <div className="absolute -top-4 -right-4 w-full h-full border-2 border-prestige/20 rounded-[2rem] z-0 hidden md:block"></div>
              <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-care/10 rounded-full z-0 hidden md:block"></div>
              <div className="rounded-[2rem] overflow-hidden shadow-2xl relative z-10 bg-white border-4 border-white group aspect-[4/3]">
                <img src={assets.img.pic1} alt={seo.servicesAlt} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}